export const GET_WEB_LINK_FIELDS_META = {
  webLink: {},
  linkAccess: {
    title: 'Project Type',
    errorMsg: 'Select project type to proceed.',
    required: true,
  },
  respondentsIds: {
    title: 'Search by name or email',
  },
  countriesIds: {
    title: 'Allowed Countries',
    errorMsg: 'Acknowledge your responsibility to proceed.',
    required: true,
  },
  responseMode: {
    title: 'Response Mode',
    errorMsg: 'Please choose response mode for this Project.',
    info: 'Allow one or multiple responses per respondent. Alternately, enable Collaboration mode, where all respondents will access a common shared response instance.',
    required: true,
  },
  allowDraft: {
    title: 'Allow Draft',
    info: 'Allow partial responses to be saved for later.',
  },
  autosaveResponse: {
    title: 'Autosave Response',
    info: 'Automatically save partial responses without the need for user to click the Save button.',
  },
  draftDocumentGeneration: {
    title: 'Draft Document Generation',
    info: 'Allow users to preview partial Documents auto-generated for Draft responses.',
  },
};
